<template>
    <div class="fw-home">
        <div class="fw-home-bg">
            <img src="./../../assets/home.png">
        </div>
        <div style="margin-top: -4px">
            <Zb v-if="tabIndex==1"/>
            <Md v-if="tabIndex==2"/>
            <Emp v-if="tabIndex==3"/>
        </div>
    </div>
</template>

<script>
    import {getCookie} from "../../utils/auth";
    import Zb from "./zb";
    import Md from "./md";
    import Emp from "./emp";

    export default {
        components: {
            Zb,
            Md,
            Emp,
        },
        data() {
            return {
                fwUser: {},
                deptId: '',
                token: '',
                tabIndex: '',
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.userType = this.fwUser.userType
            if (this.userType) {
                this.tabIndex = this.userType
            }
        },
        // mounted() {
        //     window.location.reload();
        // },
        methods: {},
    };
</script>

<style lang="scss" scoped>

    .fw-home {
        margin: 0 auto;
        height: 100%;
        background-color: #ffffff;
        position: relative;
    }

    .fw-home-bg {
        height: auto;
    }


</style>
